import React from "react";

import Box from "@components/box";
import Clickable from "@components/clickable";

import classnames from "@utils/classnames";
import placeholderImage from "@images/calendar/placeholder.png";
import playImage from "@images/play.png";

import styles from "./calendar.module.scss";

const ClickableLink = ({
  recordUrl,
  streaming,
  children,
  className,
  ...props
}) => {
  return (
    <Clickable
      className={classnames(className)}
      href={recordUrl}
      disabled={!recordUrl && !streaming}
      onClick={() => {
        if (recordUrl) {
          return;
        }
        if (streaming) {
          window.location.reload();
        }
      }}
      {...props}
    >
      {children}
    </Clickable>
  );
};

const renderCover = (className, text) => {
  return (
    <div className={classnames(styles.rightCover, styles[className])}>
      <img src={playImage} alt="play" />
      <p>{text}</p>
    </div>
  );
};

const Calendar = ({
  recordUrl,
  // streaming: streamingProp,
  color,
  time,
  title,
  label,
  desc,
  right,
  children
}) => {
  const streaming = false;
  const clickableProps = {
    recordUrl,
    streaming
  };

  let rightCover = null;
  if (streaming) {
    rightCover = renderCover("streamingCover", "直播中");
  } else if (recordUrl) {
    rightCover = renderCover("recordCover", "直播回顾");
  }
  const labels = label instanceof Array ? label : [label];
  return (
    <Box color={color} texture="spot">
      <div className={styles.calendar}>
        <div className={styles.header}>
          <ClickableLink className={styles.text} {...clickableProps}>
            <h3>
              <div>
                <span className={styles.time}>{title || time} </span>
                {streaming ? (
                  <span
                    className={classnames(styles.label, styles.streamingLabel)}
                  >
                    <img src={playImage} />
                    直播中
                  </span>
                ) : (
                  ""
                )}
              </div>
              {labels.map(l => {
                return (
                  <span key={l} className={styles.label}>
                    {l}
                  </span>
                );
              })}
            </h3>
            <p>{desc}</p>
          </ClickableLink>
          <ClickableLink className={styles.right} {...clickableProps}>
            {rightCover}
            <img src={right || placeholderImage} />
          </ClickableLink>
        </div>
        <div>{children}</div>
      </div>
    </Box>
  );
};

export default Calendar;
